import React, { Component } from "react";
import { Modal, Radio, message } from 'antd'
import 'moment/locale/zh-cn';
import '../css/print.sass';
import qs from '../../../utils/qs'


export default class Print extends Component {
    constructor(props) {
        super(props)
        this.state = {
            printData: {},
            dayFlag: 0,
            load: props.load,
            end_date_print: qs.getPrintDate(),
            type_text: '',
            searchJson: {},
            exportParam: {}
        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        console.log(nextProps, '=============')
        let { searchJson, exportParam } = nextProps;
        this.setState({
            printData: nextProps['printData'],
            searchJson,
            exportParam,
            load: nextProps.load
        })
    }

    shouldComponentUpdate(e) {
        return true;
    }

    hideVisible = () => {
        let { printData } = this.state
        printData['visible'] = false
        this.setState({
            printData
        })
    }

    tabDay = (day) => {//选择日期
        let { end_date_print } = this.state
        end_date_print = qs.getPrintDate(day);

        this.setState({
            dayFlag: day,
            end_date_print
        })
    }

    nextStep = (type) => {//类型,下一步
        let { printData } = this.state
        printData['type'] = type;//print打印，，export导出
        this.setState({
            printData,
            load: true
        })
    }

    comPrint = async () => {

        let { printData, end_date_print, type_text, searchJson, exportParam } = this.state;

        if (!type_text) { return message.error('请选择类型') };
        let exportArr = []
        if (exportParam.length) {
            exportParam.map(v => {
                exportArr.push(v.id)
                return '';
            })
        }
        searchJson['group_ids'] = exportArr;
        let param = {
            end_date: end_date_print,
            search_json: searchJson,
            type: printData['type']
        }

        //如果是print_ticket打印小票
        if (type_text === 'print_ticket') {
            return this.props.backTicket({ param })
        } else {
            console.log(printData, 'printData', printData.exportData.type_text, type_text)
            if (!printData.exportData[type_text]) return message.error('尚未生成！')
            return qs.download(printData.exportData[type_text])
        }
    }

    hideDY = () => {//隐藏打印
        this.setState({
            load: false
        })
    }

    onChange = (e) => {
        //console.log(e)
        this.setState({
            type_text: e.target.value
        })
    }

    onChangeDate = (e) => {
        this.setState({
            dayFlag: -1,
            end_date_print: qs.betweenDate(e)
        })
    }

    render() {
        let { printData, load } = this.state;
        return (
            <>
                <Modal
                    centered
                    footer={false}
                    visible={printData.type === 'print' && load}
                    title='选择打印的订单类型'
                    onCancel={this.hideDY}
                >
                    <div className='print printBox'>
                        <Radio.Group onChange={this.onChange}>
                            {/* <Radio style={({ margin: '5px 0', fontSize: '14px' })} value={1}>
                                汇总单：统计多个团购同一截单时间的商品总数和明细
                        </Radio><br /> */}
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'merchant_summary_group_batch_print_page_url'}>
                                团长对商品单：根据团长维度汇总的商品单，用于跟物流对货
                            </Radio><br />
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'group_leader_summary_group_batch_print_page_url'}>
                                团长对用户商品单：用于团长和用户核对商品信息
                            </Radio>
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'print_ticket'}>
                                打印小票
                            </Radio>
                        </Radio.Group>

                        {/* <Radio.Group onChange={this.print_ticket}>
                            <Radio style={({ margin: '5px 0', fontSize: '14px' })} value={'print_ticket'}>
                                打印小票
                            </Radio>
                        </Radio.Group> */}

                        <div style={({ height: '20px' })} />

                        <div className='flex'>
                            <div onClick={() => { this.hideDY() }} className='nextstep'>取消</div>

                            <div onClick={() => { this.comPrint() }} className='nextstep'>
                                {/* <Link to={({ pathname: 'poll'})} target="_blank">确定</Link> */}
                                确定
                            </div>
                            {/* <Link></Link> */}
                        </div>
                    </div>
                </Modal>

                <Modal
                    centered
                    footer={false}
                    visible={printData.type === 'export' && load}
                    title='选择导出的订单类型'
                    onCancel={() => this.hideDY()}
                >
                    <div className='print printBox'>
                        <Radio.Group onChange={this.onChange}>
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'dispatch_order_export_url'}>
                                调度配送单
                            </Radio>
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'products_summary_export_url'}>
                                商品汇总单
                            </Radio>
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'seller_products_export_url'}>
                                团长收货单
                            </Radio>
                            <Radio style={({ fontSize: '14px', display: 'block' })} value={'user_products_export_url'}>
                                用户明细单
                            </Radio>
                        </Radio.Group>

                        <div style={({ height: '20px' })} />

                        <div className='flex'>
                            <div onClick={() => { this.hideDY() }} className='nextstep'>取消</div>

                            {/* <div onClick={() => { this.comPrint() }} className='nextstep'>
                                确定
                            </div> */}

                            <div onClick={() => { this.comPrint() }} className='nextstep'>
                                确定
                            </div>
                            {/* <Link></Link> */}
                        </div>
                    </div>
                </Modal>
            </>
        )
    }

}